// extracted by mini-css-extract-plugin
export default {"SidebarSubmenu":"_SidebarSubmenu--nbOlF","Expanded":"_Expanded--ETcC7","ItemsWrapper":"_ItemsWrapper--Zt3YT","Desktop":"_Desktop--qNoFu","Visible":"_Visible--mqLLI"};